

// src/pages/ErrorPage.js
import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="public-page-canvas d-flex align-items-center">
      <div className="container text-center">
        <h2 className="mb-3">⚠️ Oops! Something went wrong.</h2>
        <p className="mb-4">We couldn’t connect to the server or your session expired.</p>
        <Button variant="primary" onClick={() => navigate('/')}>
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
